import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BlockProvider } from "context/ContextBlock";
import BlockSnackBar from 'components/page/Content/BlockSnackBar';
import BlockInfosPopin from 'components/page/Content/BlockInfosPopin';

import 'styles/Content.css';
import logo from 'imgs/logo.jpg';
import 'bootstrap/dist/css/bootstrap.css';
import UserHeader from './User/UserHeader';

const Content = (props) => {
  const { children } = props;
  const navigate = useNavigate();

  return (
    <BlockProvider>
      <div className="main-content">
        <div className="content-header">
          <div className="header-logo"><a onClick={() => navigate('/accueil')}><img src={logo} alt="Promete'a" /></a></div>
          <div className="header-title">Staff'In</div>
          <UserHeader />
          <div className="spacer"></div>
        </div>
        <div className="content-details">
          {children}
        </div>
      </div>
      <BlockSnackBar />
      <BlockInfosPopin />
    </BlockProvider>
  );
}

export default Content;